<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-album
            :profil="profil"
        />

        <!-- Main -->
        <main>
            <div class="albumMainBody">

                <div class="albumPages">
                    <div class="albumPage --first"></div>
                    <div class="albumPage --second"></div>
                    <div class="albumPage --third"></div>
                    <div class="albumPage --fourth"></div>
                </div>    

                <button @click="$router.push({ name: 'profil' })" class="sideMenu__close"><span class="icon"></span></button>
                <div class="albumList__separator"></div>

                <!-- Kravičky -->
                <div class="albumListing__wrap">

                    <!-- 1. strana -->
                    <div class="albumList__half --first">
                        <!-- Header -->
                        <div class="albumList__heading mb-3 d-flex align-items-center justify-content-between">
                            <h2 class="mb-0">Kolekcia <span class="icon --questionMark" @click="$bvModal.show('modalAlbumAnatomia')"></span></h2>
                            <p class="mb-0">Máš <span class="--bold">{{ countOwned }}</span> z celkových <span class="--bold">{{ countTotal }} častí</span></p>
                        </div>

                        <!-- Cow box -->
                        <div v-if="album.kravicky" class="albumListing__list --kravicky">
                            <div v-if="index >= startIndex && index <= (endIndex - 9)" 
                                 v-for="(kravicka, index) in album.kravicky" 
                                 :class="'albumListing__item' + [kravicka.current == kravicka.album_kravicky_max ? ' --done' : '']">

                                <!-- Cow -->
                                    <!--<div @click="prepModal(kravicka, index)" class="albumListing__imageWrap">
                                        <img :src="'https://www.adoptujkravicku.sk/data/foto/' + kravicka.kravicka_img_hlava" alt="" class="img-fluid">
                                    </div>-->
                                <!-- .Cow -->

                                <!-- Nálepka -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/kolekcia/' + kravicka.album_kravicky_image" alt="" class="img-fluid">
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- 2. strana -->
                    <div v-if="album.kravicky" class="albumList__half --second">
                        <!-- Cow box -->
                        <div class="albumListing__list --kravicky">
                            <div v-if="index >= (startIndex + 9) && index <= endIndex" 
                                 v-for="(kravicka, index) in album.kravicky" 
                                :class="'albumListing__item' + [kravicka.current == kravicka.album_kravicky_max ? ' --done' : '']">

                                <!-- Cow -->
                                    <!--<div @click="prepModal(kravicka, index)" class="albumListing__imageWrap">
                                        <img :src="'https://www.adoptujkravicku.sk/data/foto/' + kravicka.kravicka_img_hlava" alt="" class="img-fluid">
                                    </div>-->
                                <!-- .Cow -->

                                <!-- Nálepka -->
                                <div class="albumListing__imageWrap">
                                    <img :src="'assets/img/album/kolekcia/' + kravicka.album_kravicky_image" alt="" class="img-fluid">
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <!-- Paginácia -->
                <div v-if="prevPage != 0" @click="changePage(currentPage - 1)" class="albumListing__nav --prev">
                    <span class="icon --prev"></span>Predchádzajúca strana
                </div>
                <div v-if="nextPage != 0" @click="changePage(currentPage + 1)" class="albumListing__nav --next">
                    Ďalšia strana<span class="icon --next"></span>
                </div>

            </div>
        </main>
        
        <!-- Modal -->
        <b-modal id="modalAlbumAnatomia" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalAlbumAnatomiaTitle" aria-hidden="true" ref="modalAlbumAnatomia">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalAlbumAnatomia')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body" style="padding:0">
                <div class="text-center">

                    <h2 class="text-center">Nápoveda</h2>
                    <p class="text-18">Ako rýchlo nazbieraš všetkých 18 predmetov? Vecičky do kravičkovskej kolekcie si môžeš vykrútiť v kolese šťastia, alebo ich dostaneš ako odmenu za dosiahnuté úspechy.</p>
                    
                </div>
            </div>
            <!-- .Content -->
        </b-modal>
        <!-- .Modal -->
    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderObchod from '../partials/HeaderObchod.vue'
    import MenuAlbum    from '../partials/MenuAlbum.vue'
    export default {
        components: {
            HeaderObchod,
            MenuAlbum
        },
        props: [
            'profil',
            'album',
            'error'
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'album')
            this.toggleBodyClass('addClass', '--kravicky')
            if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                this.$emit('updateProfil')
            }

            //sessionStorage.setItem("album-kravicky", "refresh")
            this.getAlbumData('kravicky')
            this.checkPagination()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'album')
            this.toggleBodyClass('removeClass', '--kravicky')
        },
        updated() {
            if (this.updated == 0) {
                this.getAlbumData('kravicky')
            }
        },
        data() {
            return {
                countTotal: 0,
                countOwned: 0,

                prevPage: 0,
                currentPage: 0,
                nextPage: 0,
                startIndex: 0,
                endIndex: 17,

                modal_id: '',
                modal_meno: '',
                modal_img: '',
                modal_cislo: '',
                modal_dvor: '',
                modal_datum: '2019-01-01',
                modal_stav: '',

                updated: 0,

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },


            // mounted
            getAlbumData(typ) {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1

                    if ( typeof(this.album.kravicky) == 'undefined' || sessionStorage.getItem("album-kravicky") ) {
                        EventService.getAlbumData(typ)
                            .then(response => {
                                //console.log(response.data)
                                sessionStorage.removeItem("album-kravicky")

                                // progres pre získané kravičky
                                var items = response.data.data
                                this.countOwned = 0
                                this.countTotal = items.length

                                for (var i = 0; i < items.length; i++) {
                                    // album progres
                                    items[i].current = 0
                                    var key = this.profil.pouzivatel_id.album_pouzivatela.findIndex(repo => 
                                        repo.album_item_id == items[i].id &&  repo.repozitar_albumu_category == "kravicky"
                                    )

                                    if (key >= 0) {
                                        this.countOwned += 1
                                        items[i].current = parseInt(this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current)
                                    }
                                }

                                this.checkPagination()

                            // v1
                                //this.$emit('update:album', { kravicky: items })
                            // v2
                                /*if (typeof(this.album.uspechy) != 'undefined') {
                                    var emit = {
                                        uspechy: this.album.uspechy,
                                        kravicky: items
                                    }
                                    this.$emit('update:album', emit)
                                } else {
                                    this.$emit('update:album', { kravicky: items })
                                }*/
                            // v3
                                /*var emit = this.album
                                Object.assign(emit, { kravicky: items })
                                this.$emit('update:album', emit)*/
                            // v4
                                /*this.album.kravicky = items
                                this.$emit('update:album', this.album)*/

                            // v5
                                // emit alternative
                                this.$set(this.album, 'kravicky', items)
                            })
                            .catch(error => {
                                this.responseType = 'warning'
                                this.responseText = error
                            })

                    } else {
                        for (var i = 0; i < this.album.kravicky.length; i++) {
                            if (this.album.kravicky[i].current == this.album.kravicky[i].album_kravicky_max) {
                                this.countOwned += 1
                            }
                        }
                        this.countTotal = this.album.kravicky.length
                    }
                }
            },

            checkPagination() {
                if (this.countTotal > 18 || (typeof(this.album.kravicky) != 'undefined' && this.album.kravicky.length > 18)) {
                    this.nextPage = 1
                }
            },


            // click
            changePage(x) {
                // draw current page
                this.startIndex = 0 + (18 * x)
                this.endIndex   = this.startIndex + 17

                // set pages
                this.nextPage    = 0
                this.prevPage    = x
                this.currentPage = x
                if ( this.endIndex < (this.countTotal - 1) || (typeof(this.album.kravicky) != 'undefined' && this.endIndex < (this.album.kravicky.length - 1)) ) {
                    this.nextPage = 1
                }

                //console.log(x + ': ' + this.startIndex + '-' + this.endIndex)
                //console.log(this.nextPage + ': ' + this.endIndex + '>' +this.countTotal)
            },

            /*prepModal(kravicka, index) {
                if (kravicka.current == kravicka.album_kravicky_max) {
                    this.modal_id    = this.album['kravicky'][index].album_kravicky_kravicka_id
                    this.modal_meno  = this.album['kravicky'][index].kravicka_meno
                    this.modal_img   = this.album['kravicky'][index].kravicka_img_hlava
                    this.modal_cislo = this.album['kravicky'][index].kravicka_regcislo
                    this.modal_dvor  = this.album['kravicky'][index].dvor_nazov
                    this.modal_datum = this.album['kravicky'][index].kravicka_datum_nar
                    this.modal_stav  = this.album['kravicky'][index].kravicka_status
                    this.$bvModal.show('modalInfo')
                }
            },*/
        }
    }
</script>